import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IExtensionService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions.service';

let NotebookRendererMessagingService = class NotebookRendererMessagingService extends Disposable {
    constructor(extensionService) {
        super();
        this.extensionService = extensionService;
        this.activations = ( new Map());
        this.scopedMessaging = ( new Map());
        this.postMessageEmitter = this._register(( new Emitter()));
        this.onShouldPostMessage = this.postMessageEmitter.event;
    }
    receiveMessage(editorId, rendererId, message) {
        if (editorId === undefined) {
            const sends = ( [...( this.scopedMessaging.values())].map(e => e.receiveMessageHandler?.(rendererId, message)));
            return Promise.all(sends).then(s => ( s.some(s => !!s)));
        }
        return this.scopedMessaging.get(editorId)?.receiveMessageHandler?.(rendererId, message) ?? Promise.resolve(false);
    }
    prepare(rendererId) {
        if (( this.activations.has(rendererId))) {
            return;
        }
        const queue = [];
        this.activations.set(rendererId, queue);
        this.extensionService.activateByEvent(`onRenderer:${rendererId}`).then(() => {
            for (const message of queue) {
                this.postMessageEmitter.fire(message);
            }
            this.activations.set(rendererId, undefined);
        });
    }
    getScoped(editorId) {
        const existing = this.scopedMessaging.get(editorId);
        if (existing) {
            return existing;
        }
        const messaging = {
            postMessage: (rendererId, message) => this.postMessage(editorId, rendererId, message),
            dispose: () => this.scopedMessaging.delete(editorId),
        };
        this.scopedMessaging.set(editorId, messaging);
        return messaging;
    }
    postMessage(editorId, rendererId, message) {
        if (!( this.activations.has(rendererId))) {
            this.prepare(rendererId);
        }
        const activation = this.activations.get(rendererId);
        const toSend = { rendererId, editorId, message };
        if (activation === undefined) {
            this.postMessageEmitter.fire(toSend);
        }
        else {
            activation.push(toSend);
        }
    }
};
NotebookRendererMessagingService = ( __decorate([
    ( __param(0, IExtensionService))
], NotebookRendererMessagingService));

export { NotebookRendererMessagingService };
